import type { CompareAppPlanResponse } from "../../state/api.types";
import { PlanComparisonDataTable } from "../PlanComparisonTable/PlanComparisonDataTable";
import { rateComparisonToValues } from "../PlanComparisonTable/common";
import type { UsageKwh } from "./common";

type ComparisonTableProps = {
  hasSolarBuyback?: boolean;
  livePlanComparison: CompareAppPlanResponse;
  updatedPlanComparison: CompareAppPlanResponse;
  usageKwh?: UsageKwh;
  economicsOnly?: boolean;
};

export const ComparisonTable = ({
  hasSolarBuyback,
  livePlanComparison,
  updatedPlanComparison,
  usageKwh,
  economicsOnly,
}: ComparisonTableProps) => {
  const liveValues = rateComparisonToValues(
    livePlanComparison.rate,
    livePlanComparison.monthly_commission_dollars,
  );
  const updatedValues = rateComparisonToValues(
    updatedPlanComparison.rate,
    updatedPlanComparison.monthly_commission_dollars,
  );
  return (
    <PlanComparisonDataTable
      planNames={["Live", "Changes"]}
      values={[liveValues, updatedValues]}
      hasSolarBuyback={hasSolarBuyback}
      usageKwh={usageKwh}
      highlightCommission
      economicsOnly={economicsOnly}
      hideEvRows
      hideRenewableContent
    />
  );
};
